<template>
  <div class="login-component">
    <v-layout align-center v-if="mobileBigAndBelow">
      <v-flex class="logo">
        <router-link to="/">
          <img :src="'/static/images/logo/logo.png'" :alt="brand">
        </router-link>
      </v-flex>
    </v-layout>
    <div class="header">
      <v-layout class="title">
        <v-flex>
          <h1>{{ $t('MyAccount.LogInTitle') }}</h1>
        </v-flex>
        <v-flex class="close">
          <v-btn flat @click="closeLoginDialog()" class="close"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </div>
    <!-- {'hidden': errorCheck(loginErrorMessage.length > 0)} -->
    <v-form class="form-normal ctsform" @submit.prevent="login()">
      <div class="control-block" v-show="loginErrorMessage">
        <div class="msg-block tac error" v-if="loginErrorMessage === 'PLAYER_NOT_FOUND'">{{ $t('Account.Login.error.PLAYER_NOT_FOUND') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'USERNAME_CREDENTIAL_INVALID'">{{ $t('Account.Login.error.USERNAME_CREDENTIAL_INVALID') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'INVALID_CREDENTIALS'">{{ $t('Account.Login.error.INVALID_CREDENTIALS') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'InvalidCredentials'">{{ $t('Account.Login.error.InvalidCredentials') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'PLAYER_NOT_ACTIVATED'">{{ $t('Account.Login.error.PLAYER_NOT_ACTIVATED') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'USERNAME_CREDENTIAL_NOT_IN_ACTIVE_STATE'" v-html="$t('Account.Login.error.USERNAME_CREDENTIAL_NOT_IN_ACTIVE_STATE')"></div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'PLAYER_LOCKED'">{{ $t('Account.Login.error.PLAYER_LOCKED') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'TC_NOT_ACCEPTED'">{{ $t('Account.Login.error.TC_NOT_ACCEPTED') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'PLAYER_NOT_ACTIVE'">{{ $t('Account.Login.error.PLAYER_NOT_ACTIVE') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'INCORRECT_DATA'">{{ $t('Account.Login.error.INCORRECT_DATA') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'ACCOUNT_DURING_CLOSURE'">{{ $t('Account.Login.error.ACCOUNT_DURING_CLOSURE') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'INCORRECT_PLAYER_LEVEL'">{{ $t('Account.Login.error.INCORRECT_PLAYER_LEVEL') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'SESSION_LIMITS_EXCEEDED'">{{ $t('Account.Login.error.SESSION_LIMITS_EXCEEDED') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'MISSING_CREDENTIALS'">{{ $t('Account.Login.error.MISSING_CREDENTIALS') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'SESSION_HANDLING_FAILURE'">{{ $t('Account.Login.error.SESSION_HANDLING_FAILURE') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'SESSION_HANDLING_SYSTEM_FAILURE'">{{ $t('Account.Login.error.SESSION_HANDLING_SYSTEM_FAILURE') }}</div>
        <div class="msg-block tac error" v-else-if="loginErrorMessage === 'MISSING_OR_UNKNOWN_ERROR_CODE'" v-html="$t('Account.Login.error.MISSING_OR_UNKNOWN_ERROR_CODE')"></div>
        <div class="msg-block tac error" v-else>{{ $t('Account.Login.error.other') }}</div>
      </div>
      <div class="control-block clearafter" :class="{ 'filled':  loginFields.username.length > 0 }">
        <input type="text" ref="username" autocomplete="off" name="username" id="username" v-model="loginFields.username" required autofocus/>
        <label class="control-label">{{ $t('Account.Login.email')}}</label>
      </div>
      <div class="control-block clearafter" :class="{ 'filled': loginFields.password.length  > 0 }">
        <input :type="loginFields.showPassword ? 'text' : 'password'" autocomplete="off" name="password" id="password" v-model="loginFields.password" required />
        <label class="control-label">{{ $t('Account.Login.password')}}</label>
      </div>
      <span class="show_hide" @click.stop="toggleShowPassword()">{{ loginFields.showPassword ? 'Hide' : 'Show' }}</span>
      <v-layout>
        <v-flex xs12 class="float-right forgot_pass"><a @click="goToResetPassword()"><span>{{ $t('MyAccount.ForgotPass') }}</span></a></v-flex>
      </v-layout>
      <div v-if="formSubmitSppiner"><circle-loader></circle-loader></div>
      <div v-if="!formSubmitSppiner" class="buttons">
        <v-btn @click="goToRegistrationPage()" block class="primary-btn-blue join"><span>{{ $t('MyAccount.JoinNow') }}</span></v-btn>
        <v-btn type="submit" :disabled="isLoginButtonDisabled" block class="primary-btn-blue login"><span>{{ $t('MyAccount.LogIn') }}</span></v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
  import store from '@/store'
  import CircleLoader from '@/components/common/CircleLoader'
  import config from '@/config'
  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'
  import lib from '@/library'

  export default {
    name: 'login-component',

    mixins: [
      Screen,
      Branding
    ],

    data () {
      return {
        show: true,
        height: 0
      }
    },

    computed: {
      externalUrls () {
        return config.externalUrls
      },
      redirect () {
        return this.$route.params.redirect
      },
      loginChallenges () {
        return store.getters['getLoginChallenges']
      },
      loginFields () {
        return store.getters['overlayState/getloginFields']
      },
      loginDialogState () {
        return store.getters['overlayState/getLoginDialogState']
      },
      accountDetails () {
        return store.getters['getAccountDetails']
      },
      myAccountDialogState () {
        return store.getters['overlayState/getMyAccountDialogState']
      },
      loginErrorMessage () {
        return store.getters['getLoginErrorMessage']
      },
      isLoginButtonDisabled () {
        return !this.loginFields.username || !this.loginFields.password
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      formSubmitSppiner () {
        return store.getters['getFormSubmitSppiner']
      },
      gcInstallerUrl () {
        var gcData = {}
        if (process.env.NODE_ENV === 'development') {
          gcData = {url: 'stg-ums.geocomply.net', id: 'Ac7VjeFkEw'}
          return gcData
        } else if (process.env.NODE_ENV === 'production') {
          gcData = {url: 'ums.geocomply.com', id: 'LW2BYMiQ3R'}
          return gcData
        } else {
          gcData = {url: 'stg-ums.geocomply.net', id: 'Ac7VjeFkEw'}
          return gcData
        }
      },
      navigatorID () {
        if (navigator.appVersion.indexOf('Win') !== -1) {
          return 'win'
        } else if (navigator.appVersion.indexOf('Mac') !== -1) {
          return 'mac'
        } else {
          return undefined
        }
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      userAgent () {
        return lib.core.userAgent.os.name
      },
      isDebug () {
        return this.$route.query.debug
      },
      state () {
        return config.app.autoconf.STATE
      },
      brand () {
        return this.brandData
      }
    },

    methods: {
      appInstall () {
        this.closeLoginDialog()
        this.$router.push({name: 'app-installer'})
      },
      closeLoginDialog () {
        store.dispatch('overlayState/deactivateLoginDialog')
        store.dispatch('overlayState/deactivateMyAccountDialog')
      },
      login () {
        store.dispatch('login', { 'username': this.loginFields.username, 'password': this.loginFields.password })
      },
      logout () {
        store.dispatch('logout')
      },
      toggleShowPassword () {
        this.loginFields.showPassword = !this.loginFields.showPassword
      },
      redirectToDefaultPage () {
        var redirect = this.redirect || config.app.loginRedirectPage || ''
        console.log('redirect: ' + redirect)
        this.$router.push({name: redirect, params: { }})
      },
      // pluginDownload () {
      //   window.location = 'https://' + this.gcInstallerUrl.url + '/installer/url?id=' + this.gcInstallerUrl.id + '&os=' + this.navigatorID + '&version=3.1.1.3'
      // },
      clearPasswordField () {
        if (this.loginFields.password) {
          this.loginFields.password = ''
        }
      },
      goToRegistrationPage () {
        this.$router.push({ path: this.externalUrls.registration })
        this.closeLoginDialog()
      },
      goToResetPassword () {
        this.$router.push({ path: this.externalUrls.resetPassword })
        this.closeLoginDialog()
      }
    },
    mounted () {
      if (this.$route.name === 'logout') {
        this.logout()
      } else {
        if (this.isLoggedIn) {
          this.redirectToDefaultPage()
        } else {
          setTimeout(() => {
            this.$refs.username.focus()
          }, 1)
        }
      }
    },

    watch: {
      accountDetails () {
        this.redirectToDefaultPage()
      }
    },

    components: {
      CircleLoader
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/css/config"

  .login-component
    background: transparent
    text-align: center
    font-family: font-family-igt
    background: #fff
    border-radius: 5px
    @media mobile-big-and-below
      border-radius 0px

    .flex.logo
      margin: 0 0 40px 0
    p
      margin-top: 10px
      margin-bottom: 0
    p a
     color: #06283b
     font-weight: bold
     text-decoration: underline

    p a:hover
     color: #2396FC

    .float-left
      text-align: left

    .float-right
      text-align: right

    .float-right span
      color: #2396FC
      display:block
      margin-top: 6px

    .input-group
      margin: 0

    .username
      margin: 0
    .password
      margin: 0px 0 0 0

    .show_hide
      float: right
      margin: -40px 12px 0 5px
      z-index: 100
      position: relative
      color: #2396FC
      text-transform: uppercase
      cursor: pointer
      font-size: 12

    .header
      padding: 20px 0 0 0
      background: #fff
      border-radius: 4px 4px 0 0
      .title
        text-align: left
        padding: 0 20px

      h1
        margin: 0
        text-transform: uppercase
        font-size: 20px
        line-height: 36px

    .close
      flex-grow: 0
      @media mobile-big-and-below
        display: block

      .btn
        min-width: 0
        position: absolute
        top: -5px
        right: -5px
        width: 20px
        height: 20px
        // margin: 10px
        color: #b6b6b6
        >>>.btn__content
          padding: 0
        .icon
          font-weight normal

    form
      padding: 0px 20px 20px
      margin: -1px 0 0 0
      background: #fff
      border-radius: 0 0 4px 4px

    .gambilng-problem-label
      font-size 12px
      font-weight bold
      font-style: normal
      font-stretch: normal
      line-height: normal
      text-align: center

    .terms-and-conditions
      .text-label-register
        font-size 12px
        font-weight 400

    @media mobile-big-and-below
      height: 100%
      background: #fff !important
      padding: 16px !important

      .header
        text-align: left
        padding: 0 !important
        margin-top: -15px
        .title
          padding: 0

      .tc
        margin-top: 10px
        text-align: left

      p
        font-size: 14px

      form
        padding: 0px !important
        height: auto

      .logo img
        float: left
        max-height: 50px
        max-width: 150px

.login-gelocation-info
  font-size: 12px
  line-height: 17px
  text-align: left
  .login-note
    font-weight: bold
  p
    margin-top: 0px
  .gc-plugin
    margin: 0 -16px
    padding: 16px
    background: #fff
    color: #818E95
    @media tablet-and-above
      margin-top 5px
  .gc-link
    display: block
    margin-top: 10px

.login-gelocation-info-desktop
  font-size: 12px
  line-height: 17px
  text-align: left
  .login-note
    font-weight: bold
  p
    margin-top: 0px
  .gc-plugin-desktop
    background: #cfd6db
    color: #06283b
    padding: 12px 20px 20px 20px
    border-radius: 0 0 4px 4px
    .gc-info
      font-size: 12px
      font-weight: normal
      font-style: normal
      font-stretch: normal
      color: #06283b
    .btn-white
      background-color: #ffffff
      color: #1493ff
      font-size: 14px
      font-weight: bold !important
      line-height: normal
      margin-top: 12px
      margin-bottom: -34px
      height: 48px
      span
        font-weight: normal !important


  .gc-link
    display: block
@media mobile-big-and-below
  .form-normal
    border-radius 0px !important

.buttons
  display flex
  .btn.login
    margin-left 5px
  .btn.join
    margin-right 5px

</style>



// WEBPACK FOOTER //
// src/components/core/LoginComponent.vue